import React, { ReactElement } from 'react';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

import ButtonLink from 'components/ButtonLink';

export interface Props {
    handleOnDeleteClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
    handleOnSortingUpClick: (
        event: React.MouseEvent<HTMLButtonElement>
    ) => void;
    handleOnSortingDownClick: (
        event: React.MouseEvent<HTMLButtonElement>
    ) => void;
}

export default class ProductsTableRowActions extends React.PureComponent<
    Props
> {
    render(): ReactElement {
        const {
            handleOnDeleteClick,
            handleOnSortingUpClick,
            handleOnSortingDownClick
        } = this.props;

        return (
            <div className="products-table-row-actions">
                <ButtonLink
                    color="black"
                    onClick={handleOnSortingUpClick}
                    buttonProps={{ type: 'button' }}
                >
                    <ArrowUpwardIcon
                        style={{
                            fontSize: 16,
                            margin: -3
                        }}
                    />
                </ButtonLink>
                <ButtonLink
                    color="black"
                    onClick={handleOnSortingDownClick}
                    buttonProps={{ type: 'button' }}
                >
                    <ArrowDownwardIcon
                        style={{
                            fontSize: 16,
                            margin: -3
                        }}
                    />
                </ButtonLink>
                <ButtonLink
                    color="black"
                    onClick={handleOnDeleteClick}
                    buttonProps={{ type: 'button' }}
                >
                    <DeleteIcon
                        style={{
                            fontSize: 16,
                            margin: -3
                        }}
                    />
                </ButtonLink>
            </div>
        );
    }
}
